"use client";

import { usePathname } from "next/navigation";
import { PUBLIC_PATHS } from "@/lib/constants";

export const useIsPublicPage = () => {
  const pathname = usePathname();
  return PUBLIC_PATHS.some((path) => pathname.includes(path));
};
